<template>
  <div>
    <div class="sp-area">
      <div class="container-fluid"> 
        <div class="sp-nav">
          <div class="row">
            <div class="col-lg-4">
              <div class="sp-img_area">
                <div class="sp-img_slider slick-img-slider uren-slick-slider" data-slick-options='{
                                "slidesToShow": 1,
                                "arrows": false,
                                "fade": true,
                                "draggable": false,
                                "swipe": false,
                                "asNavFor": ".sp-img_slider-nav"
                                }'>
                  <div v-for="img in product.img" :key="img" class="single-slide red zoom">
                    <img :src="img" :alt="product.name">
                  </div>
                </div>
                <div class="sp-img_slider-nav slick-slider-nav uren-slick-slider slider-navigation_style-3"
                  data-slick-options='{
                                "slidesToShow": 3,
                                "asNavFor": ".sp-img_slider",
                                "focusOnSelect": true,
                                "arrows" : true,
                                "spaceBetween": 30
                                }' data-slick-responsive='[
                                        {"breakpoint":1501, "settings": {"slidesToShow": 3}},
                                        {"breakpoint":992, "settings": {"slidesToShow": 4}},
                                        {"breakpoint":768, "settings": {"slidesToShow": 3}},
                                        {"breakpoint":575, "settings": {"slidesToShow": 2}}
                                    ]'>
                  <div v-for="img in product.img" :key="img" class="single-slide red">
                    <img :src="img" :alt="product.name">
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="sp-content">
                <div class="sp-heading">
                  <h5><a href="#">{{product.name}}</a></h5>
                </div>
                <span class="reference">Reference: {{product.reference}}</span>
                <div class="rating-box">
                  <ul>
                    <li><i class="ion-android-star"></i></li>
                    <li><i class="ion-android-star"></i></li>
                    <li><i class="ion-android-star"></i></li>
                    <li class="silver-color"><i class="ion-android-star"></i></li>
                    <li class="silver-color"><i class="ion-android-star"></i></li>
                  </ul>
                </div>
                <div class="sp-essential_stuff">
                  <ul>
                    <li>Brands <a href="javascript:void(0)">{{product.brand}}</a></li>
                    <li>Availability: <a href="javascript:void(0)">{{ product.available ? 'In Stock' : 'Not Available Now'}}</a></li>
                    <li>Price: <a href="javascript:void(0)">${{product.price}}</a></li>
                  </ul>
                </div>
                <div class="quantity">
                  <label>Quantity</label>
                  <div class="cart-plus-minus">
                    <input class="cart-plus-minus-box" v-model.number="order_quantity" type="text">
                    <div class="dec qtybutton"><i class="fa fa-angle-down"></i></div>
                    <div class="inc qtybutton"><i class="fa fa-angle-up"></i></div>
                  </div>
                </div>
                <div class="qty-btn_area">
                  <ul>
                    <li><a class="qty-cart_btn" href="cart.html">Add To Cart</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Uren's Single Product Area End Here -->
  </div>
</template>

<script>
export default {
  name: "SingleProduct",
  data() {
    return {
      product: {
        name: "Product 1",
        reference: "P0Y-STANLEY",
        price: 150.25,
        available: true,
        brand: 'Stanley',
        img: [
          'images/product/large-size/1.jpg',
          ],
        desc: `Voluptatum, minus? Optio molestias voluptates aspernatur laborum ratione minima, natus
                          eaque nemo rem quisquam, suscipit architecto saepe. Debitis omnis labore laborum consectetur,
                          quas, esse voluptates minus aliquam modi nesciunt earum! Vero rerum molestiae corporis libero
                          repellat doloremque quae sapiente ratione maiores qui aliquam, sunt obcaecati! Iure nisi
                          doloremque numquam delectus.`

      },
      order_quantity: 1,
    }
  }

}
</script>

<style>

</style>
